import { Icon } from '@livable/saas-react-components';
import { FormControl, InputAdornment, InputLabel, OutlinedInput } from '@mui/material';
import React from 'react';
import RangeDatePicker from 'src/components/general/RangeDatePicker';
import { formatExtractedMoney } from 'src/pages/NewBillingModule/ApplyBillingFull/BillAutomationExtraction';
import useStyles from './styles';
const CAD_HINT = 'The common area deduction comes from the property settings.';
function ExtractedHint(_ref) {
  let value = _ref.value;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("span", {
    className: classes.extractedHint
  }, "Extracted:", /*#__PURE__*/React.createElement("span", {
    className: classes.extractedHintChip
  }, value));
}

/**
 * The inputs behind a suggested allocation (Figma: allocation table, edit state). Changes are reported
 * as they happen, so the service is asked again and the deductions, recovery and per-unit charges
 * follow along. The common area deduction is a property setting and is shown as read-only.
 */
export function AllocationSuggestionEditForm(_ref2) {
  var _ref3, _setting$billAmount, _setting$gwdPercent;
  let currency = _ref2.currency,
    onChange = _ref2.onChange,
    setting = _ref2.setting,
    table = _ref2.table;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.editForm
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.editRow
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.editField
  }, /*#__PURE__*/React.createElement(RangeDatePicker, {
    format: "MM/dd/yy",
    fromDate: table.serviceStartDate || '',
    handleDateChange: dates => onChange({
      serviceEndDate: dates.endDate,
      serviceStartDate: dates.startDate
    }),
    label: "Service dates",
    noValidate: true,
    toDate: table.serviceEndDate || ''
  }), /*#__PURE__*/React.createElement(ExtractedHint, {
    value: table.extractedPeriod
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.editField
  }, /*#__PURE__*/React.createElement(FormControl, {
    fullWidth: true,
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "bill-amount-".concat(table.key)
  }, "Bill amount"), /*#__PURE__*/React.createElement(OutlinedInput, {
    id: "bill-amount-".concat(table.key),
    label: "Bill amount",
    onChange: event => onChange({
      billAmount: event.target.value
    }),
    startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "start"
    }, "$"),
    value: (_ref3 = (_setting$billAmount = setting.billAmount) !== null && _setting$billAmount !== void 0 ? _setting$billAmount : table.extractedAmount) !== null && _ref3 !== void 0 ? _ref3 : ''
  })), /*#__PURE__*/React.createElement(ExtractedHint, {
    value: formatExtractedMoney(table.extractedAmount, currency)
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.deductions
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.sectionLabel
  }, "Deductions"), /*#__PURE__*/React.createElement("div", {
    className: classes.deductionRow
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.deductionLabel
  }, "Common Area Deduction (CAD): ", /*#__PURE__*/React.createElement("span", {
    className: classes.deductionValue
  }, table.cadPercent, "%")), /*#__PURE__*/React.createElement("span", {
    className: classes.deductionLocked,
    title: CAD_HINT
  }, /*#__PURE__*/React.createElement(Icon, {
    state: "grey",
    type: "lock-locked"
  }), "Locked")), /*#__PURE__*/React.createElement("div", {
    className: classes.deductionRow
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.deductionLabel
  }, "Good Will Deduction (GWD):"), /*#__PURE__*/React.createElement(OutlinedInput, {
    className: classes.deductionInput,
    endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "end"
    }, "%"),
    inputProps: {
      'aria-label': 'Good will deduction percent',
      max: 100,
      min: 0,
      type: 'number'
    },
    onChange: event => onChange({
      gwdPercent: event.target.value
    }),
    value: (_setting$gwdPercent = setting.gwdPercent) !== null && _setting$gwdPercent !== void 0 ? _setting$gwdPercent : table.gwdPercent
  }))));
}